import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const brandImporterSelectors = importerSelectors(
  'brand.importer',
)

export default brandImporterSelectors
